import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import toast from "react-hot-toast";

import CustomActionButton from "../../../common/CustomActionButton";
import CompanyAutocomplete from "../../../common/CustomInput/companyAutocomplete";
import CustomInputV2 from "../../../common/CustomInputV2";

import { apiCallV2 } from "../../../utils/api";
import { AddNewUserToList } from "../../../redux/user/actions";
import styled from "@emotion/styled";

let timer = null;

const AddUser = (props) => {
    const { data, setData, count, setCount, page, perPage } = props;
    const { role, name, launchDate, companyID, company } = JSON.parse(
        localStorage.getItem("admin-info")
    );
    const { myProfile } = props.Profile;
    // company Autocomplete
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
    const [selected, setSelected] = useState("");
    const [selectedSUCompany, setSelectedSUCompany] = useState(null);
    //

    const [user, setUser] = useState({
        company: localStorage.getItem("admin-info")
            ? JSON.parse(localStorage.getItem("admin-info")).company
            : "",
        firstName: "",
        lastName: "",
        emailAdd: "",
        dob: "",
        telNo: "",
        employeeNumber: "",
        location: "",
        department: "",
    });

    const [errors, setErrors] = useState({
        firstName: false,
        lastName: false,
        emailAdd: false,
        dob: false,
        telNo: false,
    });

    const handleChange = (e) => {
        setUser((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const [buttonStatus, setButtonStatus] = useState("action");

    const handleSubmit = () => {
        setErrors({
            firstName: false,
            lastName: false,
            emailAdd: false,
            dob: false,
            telNo: false,
        });
        let flag = false;
        if (!user.firstName) {
            flag = true;
            setErrors((prev) => ({ ...prev, firstName: true }));
        }
        if (!user.lastName) {
            flag = true;
            setErrors((prev) => ({ ...prev, lastName: true }));
        }
        if (!user.emailAdd) {
            flag = true;
            setErrors((prev) => ({ ...prev, emailAdd: true }));
        }

        if (flag) {
            toast.error("Please check required(*) fields!");
            return false;
        }
        return true;
    };

    const handleConfirm = async () => {
        let ssuc = null;
        if (selectedSUCompany) {
            ssuc = myProfile?.companies?.filter(
                (c) => c.company_id == selectedSUCompany
            )[0];
        }

        let tempUser =
            role === 4
                ? myProfile?.companies?.length == 1
                    ? {
                        // if company
                        ...user,
                        company: myProfile?.companies?.[0]?.company_id,
                        companyId: myProfile?.companies?.[0]?.company_id,
                        companyName: myProfile?.companies?.[0]?.name,
                        launchDate: myProfile?.companies?.[0]?.launchDate,
                    }
                    : {
                        // if company
                        ...user,
                        company: ssuc?.company_id,
                        companyId: ssuc?.company_id,
                        companyName: ssuc?.name,
                        launchDate: ssuc?.launchDate,
                    }
                : {
                    // if no company(master / developer / indi admin account)
                    ...user,
                    companyId: selected.table_id,
                    companyName: selected.name,
                    launchDate: selected.launchDate,
                };


        // asynchoronous call here
        const res = await apiCallV2(
            "POST",
            "admin/user/add-user",
            tempUser,
            localStorage.getItem("access-token")
        );

        if (res.data.status == 200) {
            const resPurchase = await apiCallV2(
                "POST",
                "create-subscription",
                {
                    first_name: user.firstName,
                    last_name: user.lastName,
                    currency: "USD",
                    plan_id: "",
                    billing_zip: "",
                    coupon_code: [],
                    startDate: new Date(
                        role === 4 ? launchDate : selected.launchDate
                    ),
                    renewal: false,
                },
                res.data.token
            );

            toast.success("User Added!");

            setUser({
                firstName: "",
                lastName: "",
                emailAdd: "",
                dob: "",
                telNo: "",
                employeeNumber: "",
                location: "",
                department: "",
            });
            setButtonStatus("saved");
            props.AddNewUserToList(res.data?.user);
            return true;
        } else if (res.data.status == 500) {
            toast.error("Failed to add user");
            setButtonStatus("action");
            return false;
        } else if (res.status == 409) {
            setButtonStatus("action");
            return false;
        }
    };

    const handleOptions = async (value) => {
        setOptions([]);
        clearTimeout(timer);
        timer = setTimeout(async () => {
            const res = await apiCallV2("POST", "common/getData", {
                page: null,
                count: null,
                tableName: "company",
                filters: { fullName: value },
                fetchAll: true,
            });
            setOptions(res.data.company);
        }, 600);
    };

    useEffect(() => { }, [selected]);


    return (
        <div id="add-user-form">
            <Box
                display="flex"
                sx={{
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {role === 4 ? (
                    <>
                        {myProfile?.companies?.length > 1 ? (
                            <FormControl fullWidth id="su-user-company-select">
                                <InputLabel id="demo-simple-select-label">
                                    Select Company
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedSUCompany}
                                    label="Company"
                                    onChange={(e) => {
                                        setSelectedSUCompany(e.target.value);
                                    }}
                                >
                                    {myProfile?.companies?.map((c, i) => {
                                        return (
                                            <MenuItem
                                                value={c.company_id}
                                                key={i}
                                            >
                                                {c.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        ) : (
                            <p
                                className="modal-content-sub-head"
                                style={{
                                    fontWeight: 700,
                                }}
                            >
                                {myProfile?.companies?.[0]?.name?.toUpperCase()}
                            </p>
                        )}
                    </>
                ) : (
                    <>
                        <CompanyAutocomplete
                            handleOptions={handleOptions}
                            open={open}
                            setOpen={setOpen}
                            loading={loading}
                            setOptions={setOpen}
                            options={options}
                            setSelected={setSelected}
                        />
                    </>
                )}
            </Box>
            <form>
                <div className="auf-form-container">
                    <div id="auf-form-inputs">
                        <CustomInputV2
                            placeholder="First Name"
                            required={true}
                            value={user.firstName}
                            onChange={handleChange}
                            name="firstName"
                            error={errors.firstName}
                        />
                        <CustomInputV2
                            placeholder="Last Name"
                            required={true}
                            value={user.lastName}
                            onChange={handleChange}
                            name="lastName"
                            error={errors.lastName}
                        />
                        <CustomInputV2
                            placeholder="Email Address"
                            required={true}
                            value={user.emailAdd}
                            type="email"
                            onChange={handleChange}
                            name="emailAdd"
                            error={errors.emailAdd}
                        />
                        <CustomInputV2
                            placeholder="Phone Number"
                            value={user.telNo}
                            type="tel"
                            onChange={handleChange}
                            name="telNo"
                            error={errors.telNo}
                        />
                        <CustomInputV2
                            placeholder="Employee ID"
                            value={user.employeeNumber}
                            onChange={handleChange}
                            name="employeeNumber"
                            error={""}
                        />
                        <CustomInputV2
                            placeholder="Location"
                            value={user.location}
                            onChange={handleChange}
                            name="location"
                            error={""}
                        />
                        <CustomInputV2
                            placeholder="Department"
                            value={user.department}
                            onChange={handleChange}
                            name="department"
                            error={""}
                        />
                    </div>

                    <div className="auf-action">
                        <CustomActionButton
                            action={async () => {
                                const res = await handleSubmit();
                                if (res == true) {
                                    return await handleConfirm();
                                } else {
                                    return false;
                                }
                            }}
                        >
                            SUBMIT
                        </CustomActionButton>
                    </div>
                </div>
            </form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    Profile: state.Profile,
});

export default connect(mapStateToProps, {
    AddNewUserToList,
})(AddUser);
